import React from "react";
import { Link } from "@quintype/components";
import { string, object, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LiveText from "../LiveText";

import "./liveNewsHeadline.m.css";

const LiveNewsHeadline = ({
  titleText = "",
  titleLink = "",
  story,
  cssStyleName,
  showDot = false,
  styles = {},
  publisherAttributes,
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  return (
    <h2 styleName={`title ${cssStyleName}`} className="headline-title live-headline-title">
      <Link href={titleLink} styleName="title-link">
        {isClosed && showDot && styles ? (
          <span
            styleName="s-dot"
            style={{ background: styles.dotColor.color !== "4d" ? styles.dotColor.color : "#ccc" }}
          >
            &nbsp;
          </span>
        ) : isClosed ? (
          ""
        ) : (
          <LiveText
            story={story}
            titleText={titleText}
            lang={publisherAttributes.lang}
            data-tracking-category={datatrackingcategory}
            data-tracking-action={datatrackingaction}
            data-tracking-label={datatrackinglabel}
          />
        )}
        {isClosed && <span className="live-text-with-title">{titleText}</span>}
      </Link>
    </h2>
  );
};

LiveNewsHeadline.propTypes = {
  titleText: string,
  titleLink: string,
  story: object,
  cssStyleName: string,
  showDot: bool,
  styles: object,
  publisherAttributes: object,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(LiveNewsHeadline);
